export default __webpack_public_path__ + "static/media/copyright.9c7e8aea.svg";